import { http } from "../../services/app/app.service";

const UserService = {
  /**
   * User Sign in api call
   * @param {object} signInData - the signin payload
   */
  signIn: (signInData: object) => {
    return http
      .post("/commonrestapi/m1342055", signInData)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * User Sign Up api call
   * @param {object} signUpData - the signup payload
   */
  signUp: (signUpData: object) => {
    return http
      .post("/electricfactoryWebsite/m2191527", signUpData)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * get employee profile data
   * @param {number} emoployeeId - the post data payload
   */
  getEmployeeProfileDetail: (employeeId) => {
    return http
      .get(`commonrestapi/m1064731/${employeeId}`)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * save employee profile data
   * @param {number} emoployeeId - the post data payload
   * @param {object} payload - the post data payload
   */
  saveEmployeeProfileDetail: (employeeId, payload) => {
    return http
      .put(`commonrestapi/m1065385/${employeeId}`, payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * send password reset link
   * @param {object} payload - the post data payload
   */
  sendResetPasswordLink: (payload) => {
    return http
      .post("commonrestapi/m1319044", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * validate reset link
   * @param {object} payload - the post data payload
   */
  validateResetKey: (payload) => {
    return http
      .post("commonrestapi/m1319043", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * save new password
   * @param {object} payload - the post data payload
   */
  saveNewPassword: (payload) => {
    return http
      .post("commonrestapi/m1319051", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * Get grid Data
   * @param {object} payload - the payload
   */
  getGridData: (payload: object) => {
    return http
      .post("/electricfactoryWebsite/m2190021", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * Get artist list
   * @param {object} payload - the payload
   */
  getArtistList: (subscriptionId, verticalId) => {
    return http
      .get(`electricfactory/m2191876/${subscriptionId}/${verticalId}`)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * get total favorite count
   * @param {object} payload - the post data payload
   */
  getTotalFavoriteCount: (employeeId) => {
    return http
      .get(`electricfactoryWebsite/m2193015/${employeeId}`)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * update favorite status
   * @param {object} payload - the post data payload
   */
  updateFavoriteStatus: (payload) => {
    return http
      .post("electricfactoryWebsite/m2193018", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * Get favorite Data
   * @param {object} payload - the payload
   */
  getFavoritesData: (payload: object) => {
    return http
      .post("/electricfactoryWebsite/m2193027", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

  /**
   * Save Share data log
   * @param {object} payload - the payload
   */
  saveShareDataLog: (payload: object) => {
    return http
      .post("/electricfactory/m2193333", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

   /**
   * Add Comment
   * @param {object} payload - the post data payload
   */
   saveComment: (payload) => {
    return http
      .post("electricfactoryWebsite/m2194169", payload)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },

   /**
   * delete comment data
   * @param {object} payload - the post data payload
   */
   deleteComment: (itemCommentId) => {
    return http
      .delete(`/electricfactoryWebsite/m2194170/${itemCommentId}`)
      .then((res) => res.data)
      .catch((error) => ({ error }));
  },
};

export default UserService;
